import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { Container } from "../Publishers/PublishersStyles";
import { toast } from "react-toastify";
import styled from "styled-components";
// import { useModal } from "../../shared/hooks/useModal";
// import Modal from "../../components/Modal/Modal";
// import Swal from "sweetalert2";

import {
  getCampaignLink,
  } from "../../redux/slices/campaignSlice";
// import {
//   getPostbackSettings,
//   createPostbackSettings,
// } from "../../redux/slices/campaignSlice";

import BackButton from "../../components/common/BackButton";
import copyIcon from "../../assets/icons/copy.svg";

const CampaignLink = () => {
  const dispatch = useDispatch();
  const { campaignId } = useParams();
  const { campaignLink } = useSelector((state) => state.campaign);

const location = useLocation();
const searchParams = new URLSearchParams(location.search);
const name = searchParams.get("name");

  //const [selectedId, setSelectedId] = useState(null);
  //const { showModal, hideModal, isModalOpen } = useModal();
  // const [formData, setFormData] = useState({
  //   timeInterval: 0,
  //   range: 0,
  //   pbPublisher: 0,
  //   pbMetaClick: 0,
  //   staticId: parseInt(selectedId),
  // });

  useEffect(() => {
    dispatch(getCampaignLink(campaignId));
  }, [dispatch, campaignId]);

  //console.log(campaignLink);

  //Postback settings
  // const handleViewClick = (id) => {
  //   setSelectedId(id); // Store the selected ID
  //   showModal("postbackSetting"); // Open the modal
  //   //console.log(id);
  //   dispatch(getPostbackSettings(id));
  // };
  
  // useEffect(() => {
  //   if (postbackSetting) {
  //     setFormData({
  //       timeInterval: parseInt(postbackSetting.timeInterval),
  //       range: parseInt(postbackSetting.range),
  //       pbPublisher: parseInt(postbackSetting.pbPublisher),
  //       pbMetaClick: parseInt(postbackSetting.pbMetaClick),
  //     });
  //   }
  // }, [postbackSetting]);
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "pbPublisher") {
  //     const publisherValue = Math.min(100, parseInt(value));
  //     setFormData((prev) => ({
  //       ...prev,
  //       pbPublisher: publisherValue,
  //       pbMetaClick: 100 - publisherValue, // Automatically calculate pbMetaClick
  //     }));
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: parseInt(value) }));
  //   }
  // };
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   //console.log(formdata, selectedId)
  //   //return
  //   dispatch(createPostbackSettings({ id: selectedId, formData })).then(() =>
  //     hideModal("postbackSetting")
  //   );
  //   setFormData({
  //     timeInterval: 0,
  //     range: 0,
  //     pbPublisher: 0,
  //     pbMetaClick: 0,
  //     staticId: null,
  //   });
  // };
  // const handleModalClose = () => {
  //   setSelectedId(null);
  //   hideModal("postbackSetting"); // Close the modal
  //   setFormData({
  //     timeInterval: 0,
  //     range: 0,
  //     pbPublisher: 0,
  //     pbMetaClick: 0,
  //     staticId: null,
  //   }); // Reset form data
  // };

  // const updateCpa = (id) => {
  //   const publisherCpa = campaignLink.find((link) => link.id === id);

  //   if (!publisherCpa) {
  //     console.error("Publisher CPA not found for the given reference.");
  //     return;
  //   }

  //   Swal.fire({
  //     title: "Update CPA",
  //     html: `
  //       <label for="publisherCPA" style="display:block; margin-bottom:5px;">Publisher CPA</label>
  //       <input id="publisherCPA" type="text" class="swal2-input" value="${publisherCpa.costPerUser}" placeholder="Enter Publisher CPA">
  //     `,
  //     confirmButtonText: "Update",
  //     showCancelButton: true,
  //     preConfirm: () => {
  //       const publisherCPA = document.getElementById("publisherCPA").value;

  //       if (!publisherCPA) {
  //         Swal.showValidationMessage("Publisher CPA value is required!");
  //         return;
  //       }

  //       return {
  //         costPerUser: parseFloat(publisherCPA),
  //       };
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       // Dispatch the update action
  //       // dispatch(updatePublisherCpa({ id, ...result.value }))
  //       //   .unwrap()
  //       //   .then(() => {
  //       //     dispatch(getCampaignLink(campaignId)); // Refresh the list
  //       //     Swal.fire(
  //       //       "Success",
  //       //       "Publisher's CPA updated successfully!",
  //       //       "success"
  //       //     );
  //       //   })
  //         // .catch((error) => {
  //         //   console.error("Failed to update publisher CPA:", error);
  //         //   //Swal.fire("Error", "Failed to update CPA. Please try again.", "error");
  //         // });
  //     }
  //   });
  // };

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };
  return (
    <Container>
      <BackButton></BackButton>
      <div className="header">
        <div className="texts">
          <h3>{name}</h3>
          <p>View all campaigns' links</p>
        </div>
        {/* <div className="link-buttons">
          <Link className="see-more" to="/campaigns">
            Export
          </Link>
        </div> */}
      </div>

      <Grid>
        {campaignLink.map((item) => (
          <GridItem key={item?.id}>
            <div className="avatar">
              {/* <img
                  src="https://via.placeholder.com/40"
                  alt="Publisher Avatar"
                /> */}
            </div>
            <div className="details">
              <h4>{item?.campaign?.campaignName}</h4>
              <p>
                <strong>Cpa:</strong> {item?.costPerUser}
              </p>
              <p className="url">
                <strong>Url:</strong> {item?.publisherCamapignUrl}
              </p>
              {/* <button onClick={() => updateCpa(item?.id)}>Update cpa</button>
              <button onClick={() => handleViewClick(item?.id)} style={{marginLeft: '5px'}}>Set postback</button> */}
            </div>
            <div className="copy-link">
              <button>
                <span role="img" aria-label="copy">
                  <img
                    src={copyIcon}
                    alt="copy"
                    onClick={() => handleCopy(item?.publisherCamapignUrl)}
                  />
                </span>
              </button>
            </div>
          </GridItem>
        ))}
      </Grid>

      {/* <Modal
        isOpen={isModalOpen("postbackSetting")}
        label="Postback Settings"
        handleClose={handleModalClose}
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Postback Time Interval (mins)</label>
            <input
              type="number"
              name="timeInterval"
              value={formData.timeInterval}
              onChange={handleChange}
              min="0"
            />
          </div>

          <div className="form-group">
            <label>Minimum Postback</label>
            <input
              type="number"
              name="range"
              value={formData.range}
              onChange={handleChange}
              min="0"
            />
          </div>

          <div className="form-group">
            <label>Postback (Publisher) %</label>
            <input
              type="number"
              name="pbPublisher"
              value={formData.pbPublisher}
              onChange={handleChange}
              min="0"
              max="100"
            />
          </div>

          <div className="form-group">
            <label>Postback (MetaClick) %</label>
            <input
              type="number"
              name="pbMetaClick"
              value={formData.pbMetaClick}
              onChange={handleChange}
              min="0"
              max="100"
              disabled
            />
          </div>

          <div className="submit">
            <div></div>
            <div className="submit-buttons">
              <button className="add-campaign" type="submit" disabled={loading}>
                {loading ? "Saving..." : "Save Settings"}
              </button>
            </div>
          </div>
        </form>
      </Modal> */}
    </Container>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0px 30px;
  margin-top: 24px;

  @media (max-width: 1476px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1076px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const GridItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;

  .avatar {
    flex-shrink: 0;
  }

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  .details {
    flex: 1;
    h4 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      text-transform: capitalize;
      margin-bottom: 10px;
    }

    p {
      margin-bottom: 10px;
      font-size: 14px;
      color: #777;
    }
    .url {
      /* Prevent long URLs from overflowing horizontally */
      word-break: break-all;
      overflow-wrap: anywhere;
      max-width: 100%;
    }
    button {
      margin-top: 5px;
      padding: 3px 10px;
      height: 30px;
      //border: 1px solid #d0d5dd;
      border-radius: 4px;
      font-size: 10px;
      //background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      //color: #344054;
      color: #fff;
      border: 1px solid #03a9f4;
      background-color: #03a9f4;
    }
  }

  .copy-link {
    button {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 20px;
      img {
        width: 20px;
        height: 20px;
        border: none;
        border-radius: 0;
      }
    }
  }
`;

export default CampaignLink;
